import React, {Component} from 'react';
import PropTypes from 'prop-types';


import Badge from '@mui/material/Badge';
import ListIcon from '@mui/icons-material/List';

const s:any = {
  badge:{
    m: 1,
  },
  hidden: {
    display: 'none'
  }
};

class SelectionAlert extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  render() {
    const { numSelected, classes } = this.props;
    return (
      <Badge
        color="secondary"
        badgeContent={numSelected}
        invisible={!numSelected}
        sx={{...s.badge}}
      >
        <ListIcon sx={{...(!numSelected&&s.hidden)}} />
      </Badge>
    );
  }
}

SelectionAlert.propTypes = {
  //classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

export default SelectionAlert;
